import React from 'react';

import { useTranslation } from 'react-i18next';

import { TasksTypes } from 'entities/task';
import { fetchGanttTasks } from 'entities/task/api/fetchGanttTasks';
import { tasksInformationActions } from 'entities/task/model/slice/tasksInformation';
import { useAppDispatch, useAppSelector } from 'store';
import { TaskFilters as Filters, ChangeTaskFilter } from 'entities/task';

import { getIsActiveTypesFilter } from '../helpers/getIsActiveTypesFilter';

export enum SelectedRadio {
    ALL = 'all',
    CUSTOM = 'custom',
    SYSTEM = 'system',
}


export const useFilterType = (
    onFilteredData: ChangeTaskFilter,
    filteredData: Filters
) => {
    const dispatch = useAppDispatch();
    const { isNeedFetchGant } = useAppSelector((state) => state.tasksInformationReducer);
    const { t } = useTranslation();
    const onChangeCheckbox = (value: TasksTypes) => (e: React.SyntheticEvent) => {
        e.stopPropagation();
        if (value === TasksTypes.GANTT && isNeedFetchGant) {
            dispatch(fetchGanttTasks());
        }
        if (filteredData.type.length === 1 && filteredData.type.includes(value)) return;
        if (filteredData.type.includes(value)) {
            if (value === TasksTypes.GANTT) {
                dispatch(tasksInformationActions.setShowGanttTabs(false));
            }
            const updatedTypes = filteredData.type.filter((item) => item !== value);


            onFilteredData('type', updatedTypes);
        } else {
            if (value === TasksTypes.GANTT) {
                dispatch(tasksInformationActions.setShowGanttTabs(true));
            }
            const updatedTypes = [...filteredData.type, value];


            onFilteredData('type', updatedTypes);
        }
    };

    const resetFilterTypes = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        onFilteredData('type', [TasksTypes.CUSTOM, TasksTypes.PAYMENT, TasksTypes.SUPPLY_REQUEST]);
    };

    const isActiveTypesFilter = getIsActiveTypesFilter(filteredData.type);

    const getSelectedItemText = () => {
        const typesMapping = {
            [TasksTypes.CUSTOM]: t('useFilterType.getSelectedItemText.typesMapping.CUSTOM'),
            [TasksTypes.PAYMENT]: t('useFilterType.getSelectedItemText.typesMapping.PAYMENT'),
            [TasksTypes.SUPPLY_REQUEST]: t(
                'useFilterType.getSelectedItemText.typesMapping.SUPPLY_REQUEST'
            ),
            [TasksTypes.GANTT]: t('useFilterType.getSelectedItemText.typesMapping.GANTT'),
        };

        const filtersItem = [
            TasksTypes.CUSTOM,
            TasksTypes.PAYMENT,
            TasksTypes.SUPPLY_REQUEST,
            TasksTypes.GANTT,
        ];

        return filtersItem
            .filter((type) => filteredData.type.includes(type))
            .map((type) => typesMapping[type])
            .join(', ');
    };
    const selectedItemText = getSelectedItemText();

    return { onChangeCheckbox, isActiveTypesFilter, resetFilterTypes, selectedItemText };
};

export { TasksTypes } from 'entities/task';
